import React from "react";
import {WithTranslation, withTranslation} from "react-i18next";
import {InstallationEquipment} from "../../../models/operations/InstallationEquipment";
import DisplayEquipment from "../DisplayEquipment";

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    /**
     * Operation to display.
     */
    operation: InstallationEquipment;
}

/**
 * Displays the installation-specific attributes of a piece of equipment.
 * @author Alizée Grand
 * @version 1.1
 * @creation 29/06/2022
 * @last_update 11/07/2022
 **/
class DisplayEquipmentInstallation extends React.Component<Props> {

    render() {

        /**
        * Retrieves from the props the function to access the translation.
        **/
        const getTranslation = this.props.t;

        return (
            <React.Fragment>
                <span><b>{getTranslation("display.operation.equipment-installation.title")}</b> : </span>
                <br/>
                <DisplayEquipment equipment={this.props.operation.equipment!}/>
                <br/>
            </React.Fragment>
        );

    };

}

export default withTranslation()(DisplayEquipmentInstallation);
